import { createFromIconfontCN } from "@ant-design/icons";
export const IconFont = createFromIconfontCN({
	scriptUrl: [
		"//at.alicdn.com/t/font_1771257_fpbzal22piw.js"
	],
});
